import { render } from "./Recruiterlist.vue?vue&type=template&id=6fd3b444&scoped=true"
import script from "./Recruiterlist.vue?vue&type=script&lang=js"
export * from "./Recruiterlist.vue?vue&type=script&lang=js"

import "./Recruiterlist.vue?vue&type=style&index=0&id=6fd3b444&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd3b444"]])

export default __exports__